import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActiveMemberState } from './active-member.state';

export const selectMemberState =
  createFeatureSelector<ActiveMemberState>('active-member');

export const selectActiveMember = createSelector(
  selectMemberState,
  (state: ActiveMemberState) => state.activeMember
);

export const selecMemberCount = createSelector(
  selectMemberState,
  (state: ActiveMemberState) => state.memberCount
);
